const Cookies = require('cookies')
const jwt = require('jsonwebtoken')
const cryptoRandomString = require('crypto-random-string')
const Cryptr = require('cryptr')
const axios = require('axios')
const crypto = require('crypto')
const PHPUnserialize  = require('php-unserialize')
const compare = require('secure-compare')

/**
 * Authenticator class
 */
module.exports = class Authenticator {
    /**
     * Authenticator class constructor
     */
    constructor(request, response, env) {
        this.request = request
        this.response = response
        this.token = null
        this.authenticatedObject = {
            auth: {
                isAuthenticated: false,
                userId: false,
                name: false,
                site_owner: false,
                site_user: false,
                site_downline:false,
                site_user_email:null,
                site_domain:null,
                contactId: false,
            }
        }
        this.env = env

        let headerCollection, headers, authHeader, jsonHeaders = this.constructor.getJSONHeaders()

        headers = this.request.headers

        authHeader = {
            "Authorization": `Bearer ${this.env.AUTH_SERVER_AUTHORIZATION_KEY}`
        }

        headerCollection = { ...headers, ...authHeader, ...jsonHeaders, }

        delete headerCollection["host"]

        this.axiosInstance = axios.create({
            baseURL: this.constructor.getAuthServerDomain(this.env),
            timeout: 10000,
            headers: headerCollection
        })
    }

    static getAuthServerDomain(env){
        var authServerDomain;
        switch (env.APP_ENV)
        {
            case "dev":
                authServerDomain = env.LOCAL_AUTH_SERVER_DOMAIN
                break
            case "sandbox":
                authServerDomain = env.SANDBOX_AUTH_SERVER_DOMAIN
                break
            case "staging":
                authServerDomain = env.STAGING_AUTH_SERVER_DOMAIN
                break
            case "production":
            default:
                authServerDomain = env.PRODUCTION_AUTH_SERVER_DOMAIN
                break
        }

        return authServerDomain;
    }

    /**
     * Method to setup CSRF token for the site
     */
    setCsrf() {
        const cookies = new Cookies(this.request, this.response)
        const cryptr  = new Cryptr(this.env.COOKIE_SECRET)

        const randomString = cryptoRandomString({length: 6, type: 'base64'})
        const timestamp    = Math.floor(Date.now() / 1000)
        const encrypted    = cryptr.encrypt(`${randomString}-${timestamp}`)
        const metaCsrf     = Buffer.from(`${randomString}-${timestamp}`).toString('base64')

        cookies.set(this.env.COOKIE_CSRF_NAME, encrypted, {
            httpOnly: true,
            secure: (this.env.SECURE_COOKIE == 'true')
        })

        return {
            metadata: {
                csrf: cryptr.encrypt(metaCsrf)
            }
        }
    }

    /**
     * check if user is auth in auth server
    */
    async checkAuthUser(req) {

        //const ip =  req.headers["x-real-ip"] || req.connection.remoteAddress;
        const ip =  req.headers["x-forwarded-for"] || req.connection.remoteAddress;
        
        const userAgent = req.headers['user-agent'];
        console.log({ userAgent });
        console.log('User IP: ',ip);

        let hasError, _response;

        const post = {
            ip: ip,
            userAgent: userAgent,
            domain: this.request.headers.host,
           };

        _response = await this.axiosInstance.post(`/?action=check-identity-user`, post)
            .then((response) => this.constructor.handleResponse(response))
            .catch(function(error) {
                console.log(`Error get auth info about user: ${error}`)
            })

        console.log({_response});
 
        console.log('getToken checkAuthUser _response', _response)
        if (typeof _response === 'object') {
            if(_response.code == 200){

                this.authenticatedObject.auth.isAuthenticated = _response.isAuthenticated;
                this.authenticatedObject.auth.userId = _response.userId;
                this.authenticatedObject.auth.name = _response.name;
                this.authenticatedObject.auth.site_owner = _response.site_owner;
                this.authenticatedObject.auth.site_user_email = _response.site_user_email;
                this.authenticatedObject.auth.contactId = _response.contactId;
            }
        }
        
        return _response;
    }
    /**
     * Sets up the session cookie
     */
    setSessionCookie(isAuthenticated = false, cookieName) {
        let authObj = this.authenticatedObject, authObjString

        authObj.auth.isAuthenticated = isAuthenticated
        authObjString = this.getAuthenticationString(authObj)
        this.setTokenCookie(authObjString, cookieName)
    }

    /**
     * Sets up the initial auth cookie if it does not exists
     */
    setAuthenticationSession() {
        let authObj = this.getTokenCookie(this.env.AUTH_SERVER_SESSION_NAME)
        if (typeof authObj === "undefined") {
            authObj = this.getAuthenticationString(this.authenticatedObject)
            this.setTokenCookie(authObj, this.env.AUTH_SERVER_SESSION_NAME, false)
        }

        return JSON.parse(Buffer.from(authObj, "base64").toString())
    }

    /**
     * Converts authentication object to a browser friendly string
     * @param {array|object} authObj
     */
    getAuthenticationString(authObj) {
        return Buffer.from(JSON.stringify(authObj)).toString("base64")
    }

    /**
     * Validates and extracts user data from a hashed string from Yii
     *
     * @returns {object} Object that contains authenticated boolean and userKey if available
     */
    getAuthenticatedUserKey(userKey) {
        let testHash, refHash, refData, freshHash, alg = "sha256", digest = "hex", reference, key

        reference = Buffer.from(userKey, 'base64').toString()
        testHash  = crypto.createHmac(alg, "").update("").digest(digest)
        refHash   = reference.substring(0, testHash.length)

        if (refHash.length === testHash.length) {
            refData = reference.substring(refHash.length)
            freshHash = crypto.createHmac(alg, this.env.AUTH_SERVER_TOKEN_PRIVATE_KEY).update(refData).digest(digest)

            if (compare(refHash, freshHash) === true) {
                key = PHPUnserialize.unserialize(refData)
            }
        }

        return key
    }

    /**
     * Method to get cookie token from the browser
     * @param {string} name Cookie name
     */
    getTokenCookie(name) {
        const cookies = new Cookies(this.request, this.response, {
            keys: [this.env.AUTH_SERVER_COOKIE_KEYS]
        })
        return cookies.get(name)
    }

    /**
     * Method to get sign in url
     *
     * @returns {string}
     */
    static getSignInUrl(url, _authDomain, backofficeDomain="") {

        if (url != '') {
            const hostname = url.origin
            const next = Buffer.from(url.href).toString('base64')
            const authDomain = _authDomain
            const domain = backofficeDomain ? backofficeDomain : url.hostname
            const localAuthenticate = Buffer.from(`${hostname}/api/authenticate?next=${next}`).toString('base64')
            const signUrl = `${authDomain}verify?domain=${domain}&continue=${localAuthenticate}`

            return signUrl
        }

        return
    }

    /**
     * Method to get sign in url
     *
     * @returns {string}
     */
    static getCartSignInUrl(url, _authDomain, backofficeDomain="") {

        if (url != '') {
            const hostname = url.origin
            const next = Buffer.from(url.href).toString('base64')
            const authDomain = _authDomain
            const domain = backofficeDomain ? backofficeDomain : url.hostname
            const localAuthenticate = Buffer.from(`${hostname}/api/authenticate?next=${next}`).toString('base64')
            const signUrl = `${authDomain}cart-login?domain=${domain}&continue=${localAuthenticate}`

            return signUrl
        }

        return
    }

    /**
     * Method to get auto sign in url
     *
     * @returns {string}
     */
     static getCartAutoSignInUrl(url, _authDomain, backofficeDomain="") {

        if (url != '') {
            const hostname = url.origin
            const next = Buffer.from(url.href).toString('base64')
            const authDomain = _authDomain
            const domain = backofficeDomain ? backofficeDomain : url.hostname

            //continue param will be added in the components function
            const signUrl = `${authDomain}cart-login?domain=${domain}&auto=1`

            return signUrl
        }

        return
    }

    /**
     * Method to get auto sign in url
     *
     * @returns {string}
     */
     static getAutoSignInUrl(url, _authDomain, backofficeDomain="") {

        if (url != '') {
            const hostname = url.origin
            const next = Buffer.from(url.href).toString('base64')
            const authDomain = _authDomain
            const domain = backofficeDomain ? backofficeDomain : url.hostname

            //continue param will be added in the components function
            const signUrl = `${authDomain}verify?domain=${domain}&auto=1`

            return signUrl
        }

        return
    }

    /**
     * Method to get sign in url with backoffice
     *e
     * @returns {string}
     */
    static getAutoBackofficeSignInUrl(url, env) {

        if (url != '') {
            const authDomain = env.authDomain
            const backofficeDomain = env.backofficeDomain
            const next = Buffer.from(`${backofficeDomain}activate-trial`).toString()
            const localAuthenticate = Buffer.from(`${backofficeDomain}signin?next=${next}`).toString('base64')
            const signUrl = `${authDomain}verify?domain=${backofficeDomain}&continue=${localAuthenticate}`

            return signUrl
        }

        return
    }

    /**
     * Method to get password reset url
     *
     * @returns {string}
     */
     static getPasswordResetUrl(url, _authDomain) {

        if (url != '') {
            const hostname = url.origin
            const next = Buffer.from(url.href).toString('base64')
            const authDomain = _authDomain
            const domain = url.host
            const localAuthenticate = Buffer.from(`${hostname}/login`).toString('base64')
            const signUrl = `${authDomain}recovery?domain=${domain}&continue=${localAuthenticate}`

            return signUrl
        }

        return
    }

    /**
     * Method to set cookie token to the browser
     * @param {string} token JWT string
     */
    setTokenCookie(value, name, signed = true, $domainExclude=false, $sameSite=true) {
        const cookies = new Cookies(this.request, this.response, {
            keys: [this.env.AUTH_SERVER_COOKIE_KEYS]
        })

        // Sets the cookie token from the authentication server
        if ($domainExclude) {
            cookies.set(name, value, {
                httpOnly: true,
                sameSite: $sameSite,
                signed: signed,
                secure: (this.env.SECURE_COOKIE == 'true')
            })
        }else{
            cookies.set(name, value, {
                httpOnly: true,
                sameSite: $sameSite,
                signed: signed,
                secure: (this.env.SECURE_COOKIE == 'true'),
                domain: this.env.COOKIE_BASE_DOMAIN
            })
        }
        
    }

    /**
     * Method to remove a cookie
     * @param {string} name cookie name
     */
    removeTokenCookie(name) {
        const cookie = new Cookies(this.request, this.response, {
            keys: [this.env.AUTH_SERVER_COOKIE_KEYS]
        })
        cookie.set(name)
        cookie.set(`${name}.sig`)
    }

    /**
     * Method to verify POST requests passing through the site
     */
    verifyRequests() {
        if (this.request.method === 'POST')
        {
            const cookies = new Cookies(this.request, this.response)
            const cryptr  = new Cryptr(this.env.COOKIE_SECRET)

            let cookie = cookies.get(this.env.COOKIE_CSRF_NAME)
            cookie = !cookie ? null : cryptr.decrypt(cookie)

            let csrf = this.request.body.csrf
            csrf = cryptr.decrypt(csrf)
            csrf = Buffer.from(csrf, 'base64').toString()

            if (cookie === csrf) {
                return true
            }

            this.response.json(JSON.stringify({
                token: null,
                code: 400,
                message: 'Invalid csrf token!'
            }))
        }
    }

    /**
     * Method to verify tokens provided from the authentication server
     *
     * @param {string} token Cookie string
     */
    verifyToken(token) {
        let host = this.request.headers.host
        let authenticatedObject = this.authenticatedObject
        return jwt.verify(token, this.env.AUTH_SERVER_TOKEN_PRIVATE_KEY, function(error, decoded) {
            if (typeof decoded === "object") {
                if (typeof decoded.auth !== "undefined") {
                    let _auth, auth = decoded.auth
                    _auth = authenticatedObject.auth
                    authenticatedObject.auth = { ..._auth, ...auth }
                }

                if (decoded.aud === host) {
                    return true
                }
            }

            if (error) {
                console.log(`Invalid token: ${JSON.stringify(error)}\n`)
            }

            return
        })
    }

    /**
     * Checks Request Obj if `reference` query exists from the url
     */
    async checkReference() {
        if (typeof this.request.query.ref !== "undefined") {
            let reference = Buffer.from(this.request.query.ref, 'base64').toString()
            return await this.validateReference(reference)
        }
    }

    /**
     * Validates strings created by Yii::$app->security->hashData() with the same validation logic
     *
     * @param {string} reference
     */
    async validateReference(reference) {
        let authObj, testHash, refHash, refData, freshHash, alg = "sha256", digest = "hex", token

        testHash = crypto.createHmac(alg, "").update("").digest(digest)
        refHash = reference.substring(0, testHash.length)
        authObj = this.authenticatedObject

        if (refHash.length === testHash.length) {
            refData = reference.substring(refHash.length)
            freshHash = crypto.createHmac(alg, this.env.AUTH_SERVER_TOKEN_PRIVATE_KEY).update(refData).digest(digest)

            if (compare(refHash, freshHash) === true) {
                token = await this.getToken(PHPUnserialize.unserialize(refData))
                if (this.verifyToken(token) === true) {
                    this.token = token
                    // Set `isAuthenticated` property as true before storing it as cookie
                    authObj.auth.isAuthenticated = true
                    this.setTokenCookie(this.getAuthenticationString(authObj), this.env.AUTH_SERVER_SESSION_NAME, false)
                    return true
                }
            }
        }

        // Guest is set as unauthenticated
        this.setTokenCookie(this.getAuthenticationString(authObj), this.env.AUTH_SERVER_SESSION_NAME, false)
        return
    }

    /**
     * Fetches a new token provided by the authentication server
     * @param {string} referenceEmail email address from the `ref` request query
     */
    async getToken(referenceEmail = false) {
        let hasError, _response

        if (referenceEmail === false) {
            _response = await this.axiosInstance.get('/', {
                params: {
                    action: this.env.AUTH_SERVER_CHECK_SESSION,
                    domain: this.request.headers.host
                }
            })
            .then((response) => this.constructor.handleResponse(response))
            .catch(function(error) {
                console.log(`Error checking session: ${error}`)
                hasError = true
            })
            console.log('getToken _response', _response)
        }
        else {
            _response = await this.axiosInstance.get('/', {
                params: {
                    action: this.env.AUTH_SERVER_CHECK_SESSION,
                    domain: this.request.headers.host,
                    email: referenceEmail
                }
            })
            .then((response) => this.constructor.handleResponse(response))
            .catch(function(error) {
                console.log(`Error checking session: ${error}`)
                hasError = true
            })
            console.log('getToken _response', _response)
        }

        if (!hasError) {
            if (typeof _response === "object") {
                if (_response.code === 404) {
                    console.log(`Removing session cookies: ${JSON.stringify(_response)}\n`)
                    return false;
                }

                if (_response.user !== '') {
                    let userInfo = this.getAuthenticatedUserKey(_response.user)

                    this.authenticatedObject.auth.userId = userInfo.userId
                    this.authenticatedObject.auth.name = userInfo.name
                    this.authenticatedObject.auth.site_owner = userInfo.site_owner
                    this.authenticatedObject.auth.site_domain = userInfo.site_domain
                    this.authenticatedObject.auth.site_user_email = userInfo.site_user_email
                    this.authenticatedObject.auth.site_user = userInfo.site_user
                    this.authenticatedObject.auth.contactId = userInfo.contactId
                    this.authenticatedObject.auth.site_downline = userInfo.site_downline
                }

                if (_response.code === 200 && _response.token !== "") {
                    return _response.token
                }
            }
            else {
                console.log(`Response is not an object: ${JSON.stringify(_response)}\n`)
            }
        }

        return
    }

    /**
     * @param {string} auth_token auth token from the `auth_token` request query
     */
    async authenticate(auth_token) {
        let hasError, _response

        _response = await this.axiosInstance.get('/', {
            params: {
                action: this.env.AUTH_SERVER_AUTHENTICATE_SESSION,
                domain: this.request.headers.host,
                auth_token: auth_token
            }
        })
            .then((response) => this.constructor.handleResponse(response))
            .catch(function (error) {
                console.log(`Error authenticate: ${error}`)
                hasError = true
            })

        if (!hasError) {
            if (typeof _response === "object") {
                if (_response.code === 404) {
                    console.log(`Removing session cookies: ${JSON.stringify(_response)}\n`)
                    return false;
                }

                if (_response.user !== '') {
                    let userInfo = this.getAuthenticatedUserKey(_response.user)

                    this.authenticatedObject.auth.userId = userInfo.userId
                    this.authenticatedObject.auth.name = userInfo.name
                    this.authenticatedObject.auth.site_owner = userInfo.site_owner
                    this.authenticatedObject.auth.site_domain = userInfo.site_domain
                    this.authenticatedObject.auth.site_user_email = userInfo.site_user_email
                    this.authenticatedObject.auth.site_user = userInfo.site_user
                    this.authenticatedObject.auth.contactId = userInfo.contactId
                    this.authenticatedObject.auth.site_downline = userInfo.site_downline

                    this.setTokenCookie(userInfo.user_id, 'user_id')
                    this.setTokenCookie(userInfo.contact_id, 'contact_id')
                }

                if (_response.code === 200 && _response.token !== "") {
                    return _response.token
                }
            }
            else {
                console.log(`Response is not an object: ${JSON.stringify(_response)}\n`)
            }
        }

        return
    }

    /**
     * Function to submit an authentication request to the auth server
     */
    async login() {
        const verify = this.verifyRequests()

        if (verify) {
            let _response, post, postBody, requestDomain, postDomain = {}

            postBody = this.request.body
            postDomain = {
                domain: this.request.headers.host,
                contact_allowed: this.env.CONTACT_ALLOWED
            }

            post = { ...postBody, ...postDomain }

            _response = await this.axiosInstance.post(`/?action=${this.env.AUTH_SERVER_VALIDATE_CREDENTIALS}`, post)
                .then((response) => this.constructor.handleResponse(response))
                .catch(function(error) {
                    console.log(`Error logging in user: ${error}`)
                })

            if (typeof _response === "object") {
                if (_response.code === 200) {
                    let verifyToken = this.verifyToken(_response.token)

                    if (verifyToken) {

                        if(this.request.query.continue !== 'undefined') {
                            requestDomain = this.request.query.continue;
                        }else {
                            requestDomain = this.request.query.redirect;
                        }

                        return {
                            token: _response.token,
                            code: _response.code,
                            redirect: requestDomain,
                            user_id: _response.user_id,
                            contact_id: _response.contact_id,
                            country: _response.country
                        }
                    }
                    else {
                        return {
                            token: '',
                            code: _response.code
                        }
                    }
                }
            }

            return _response
        }
    }

    /**
     * Method to submit a request to the authentication server and terminate active sessions
     * related to the IP and User Agent from the request
     */
    async logout() {
        let _response, cookie

        cookie = new Cookies(this.request, this.response, {
            keys: [this.env.AUTH_SERVER_COOKIE_KEYS]
        })

        _response = await this.axiosInstance.post(`/?action=${this.env.AUTH_SERVER_TERMINATE_SESSION}`, {})
            .then((response) => this.constructor.handleResponse(response))
            .catch(function(error) {
                console.log(`Error logging out user: ${error}`)
            })

        if (typeof _response === "object") {
            if (_response.code === 200) {
                return {
                    code: _response.code,
                    message: _response.message
                }
            }
        }

        return _response
    }

    /**
     * Handles custom redirection
     *
     * @param {string} url
     */
    handleRedirect(url) {
        let location, headers = this.request.headers, headerCollection
        location = { "Location": url }
        headerCollection = { ...headers, ...location, }
        this.response.writeHead(302, headerCollection)
        this.response.end()
    }

    /**
     * Static JSON headers for external fetch() requests
     */
    static getJSONHeaders() {
        return {
            "Content-Type": "application/json",
            "accept": "application/json"
        }
    }

    /**
     * Method to handle response from fetch()
     * @param {} response Response object
     */
    static handleResponse(response) {
        if (response.status === 200) {
            return response.data
        }

        throw Error(response.statusText)
    }

    /**
     * Method to redirect site visitor an specified page when not authenticated
     *
     * @param Object auth props from getServerSideProps()
     * @param string redirectTo optional link to redirect the visitor
     */
    static visitorIsAuthenticated(auth, redirectTo = false) {
        if (!auth.isAuthenticated) {
            if (typeof window !== "undefined") {
                if (redirectTo === false)
                    redirectTo = '/'
                window.location.href = redirectTo
            }
        }
    }

    /**
     * Static function that can be used to logout authenticated users
     *
     * @param string redirectUrl URL string to redirect user after logout, defaults to '/'
     */
    static preLogout(redirectUrl) {
        if (typeof redirectUrl === "undefined") {
            redirectUrl = "/"
        }

        axios.post('/api/logout', {})
            .then(function (response) {
                console.log('Logging out....');
                if(typeof response.data === 'object'){
                    if (response.data.message) {
                        window.location.href = redirectUrl
                    }
                }else{
                    if (typeof JSON.parse(response.data) === 'object'){
                        let responseObj = JSON.parse(response.data)
                        if (responseObj.message) {
                            window.location.href = redirectUrl
                        }
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            })
    }

    //auto signin functions for wellness, business and hub

    /**
     * Check session if exists and return reference email
     */
     async autoCheckSession($host=null,$email=null) {
        let hasError, _response

        if ($email){
            _response = await this.axiosInstance.get('/', {
                params: {
                    action: 'auto-check-session',
                    domain: this.request.headers.host,
                    email: $email
                }
            })
            .then((response) => this.constructor.handleResponse(response))
            .catch(function(error) {
                console.log(`Error checking session: ${error}`)
                hasError = true
            })
        }else{
            if ($host == null) {
                _response = await this.axiosInstance.get('/', {
                    params: {
                        action: 'auto-check-session',
                        domain: this.request.headers.host,
                    }
                })
                .then((response) => this.constructor.handleResponse(response))
                .catch(function(error) {
                    console.log(`Error checking session: ${error}`)
                    hasError = true
                })
            }else{
                _response = await this.axiosInstance.get('/', {
                    params: {
                        action: 'auto-check-session',
                        domain: $host
                    }
                })
                .then((response) => this.constructor.handleResponse(response))
                .catch(function(error) {
                    console.log(`Error checking session: ${error}`)
                    hasError = true
                })
            }
            
        }
        
        
        
        if (!hasError) {
            if (typeof _response === "object") {

                if (_response.code === 404) {
                    console.log(`Removing session cookies: ${JSON.stringify(_response)}\n`)
                    return false;
                }

                if (_response.code === 200) {
                    if ( _response.ref !== "") {
                        return _response.ref
                    }
                }
            }
            else {
                console.log(`Response is not an object: ${JSON.stringify(_response)}\n`)
            }
        }

        return
    }

    /**
     * Function to automatically submit an authentication request to the auth server
     */
     async autoLogin(data) {
         
        let _response, post, postDomain = {}
        let Data = data
        
        postDomain = {
            domain: this.request.headers.host,
            contact_allowed: this.env.CONTACT_ALLOWED
        }

        post = { ...Data, ...postDomain }

        _response = await this.axiosInstance.post(`/?action=validate-reference`, post)
            .then((response) => this.constructor.handleResponse(response))
            .catch(function(error) {
                console.log(`Error logging in user: ${error}`)
            })

        if (typeof _response === "object") {
            if (_response.code === 200) {
                let verifyToken = this.verifyToken(_response.token)

                if (verifyToken) {

                    return {
                        token: _response.token,
                        code: _response.code,
                        user_id: _response.user_id,
                        contact_id: _response.contact_id
                    }
                }
                else {
                    return {
                        token: '',
                        code: _response.code,
                        user_id: '',
                        contact_id: ''
                    }
                }
            }
        }

        return _response
    }

    /**
     * Function to call auto login function
     */
     async preAutoLogin() {
        const verify = this.verifyRequests()

        if(verify){
            let _response = await this.autoLogin(this.request.body)
            return _response
        }
    }

    setUnauthenticationSession($domainExclude=false) {
        
        let  authObj = this.getAuthenticationString(this.authenticatedObject)
        this.setTokenCookie(authObj, this.env.AUTH_SERVER_SESSION_NAME, false, $domainExclude)
        
        return JSON.parse(Buffer.from(authObj, "base64").toString())
    }
    
    async autoCheckSessionMainDomain() {
        let hasError, _response

        _response = await this.axiosInstance.get('/', {
            params: {
                action: 'auto-check-session-main-domain',
                domain: this.request.headers.host,
            }
        })
        .then((response) => this.constructor.handleResponse(response))
        .catch(function(error) {
            console.log(`Error checking session: ${error}`)
            hasError = true
        })
        
        
        if (!hasError) {
            if (typeof _response === "object") {

                if (_response.code === 404) {
                    console.log(`Removing session cookies: ${JSON.stringify(_response)}\n`)
                    return false;
                }

                if (_response.code === 200) {
                    if ( _response.ref !== "") {
                        return _response.ref
                    }
                }
            }
            else {
                console.log(`Response is not an object: ${JSON.stringify(_response)}\n`)
            }
        }

        return
    }
}